import React, { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import AnimatedHeading from "./AnimatedHeading";
import useMotionGuard from "../hooks/useMotionGuard";

const STEPS = [
    { n: "Step 01", h: "Configuriamo la piattaforma",   b: "Adattiamo il sistema al tuo modello di offerta." },
    { n: "Step 02", h: "Modulistica e offerte pronte",  b: "Contratti, condizioni, template ARERA-compliant." },
    { n: "Step 03", h: "Formazione",                    b: "Il tuo team impara a usare la macchina." },
    { n: "Step 04", h: "Vai in produzione",             b: "Il primo cliente entra. Da quel momento vendi." },
];

export default function SectionPath() {
    const timelineRef = useRef(null);
    const { reduced } = useMotionGuard();

    const { scrollYProgress } = useScroll({
        target: timelineRef,
        offset: ["start 80%", "end 60%"],
    });
    const fillScaleX = useSpring(scrollYProgress, {
        stiffness: 80,
        damping: 22,
        mass: 0.35,
        restDelta: 0.001,
    });

    return (
        <section className="lp-section" aria-labelledby="s-path">
            <div className="lp-container">
                <div className="lp-section-head">
                    <motion.div
                        className="lp-eyebrow lp-section-eyebrow"
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <span className="lp-eyebrow-accent">03</span> &nbsp;/&nbsp; Il percorso
                    </motion.div>
                    <AnimatedHeading
                        as="h2"
                        id="s-path"
                        className="lp-h2"
                        text="Come partiamo insieme."
                    />
                    <motion.p
                        className="lp-body-lg lp-section-sub"
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
                    >
                        Un percorso chiavi in mano, senza sorprese.
                    </motion.p>
                </div>
                <motion.div
                    ref={timelineRef}
                    className="lp-timeline"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ staggerChildren: 0.15 }}
                >
                    {!reduced && (
                        <motion.div
                            className="lp-timeline-fill"
                            aria-hidden="true"
                            style={{ scaleX: fillScaleX }}
                            data-testid="timeline-fill"
                        />
                    )}
                    {STEPS.map((s) => (
                        <motion.div
                            key={s.n}
                            className="lp-step"
                            variants={{
                                hidden: { opacity: 0, y: 20 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
                            }}
                        >
                            <motion.span
                                className="lp-step-dot"
                                variants={{
                                    hidden: { scale: 0 },
                                    visible: { scale: 1, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
                                }}
                            />
                            <div className="lp-step-num">{s.n}</div>
                            <h3 className="lp-step-h">{s.h}</h3>
                            <p className="lp-step-body">{s.b}</p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
